module.exports = __webpack_public_path__ + "img/400f.648f502a.png";